import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants.js";

export const NewLifeStyled = styled.div`
    flex: 1 0 auto;
    position: relative;
`;

export const NewLifeHeaderStyled = styled.div`
    font-weight: 800;
    font-size: 48px;
    margin-bottom: 24px;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        font-size: 24px;
    }
`;

export const NewLifeSubHeaderStyled = styled.div`
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 24px;
    color: var(--color-secondary);

    @media (max-width: ${BREAKPOINTS.medium}px) {
        font-size: 16px;
    }
`;

export const NewLifeAccountButtonsStyled = styled.div`
    display: flex;
    flex-direction: row;

    justify-content: center;

    margin-left: 8px;
    margin-right: 8px;
`;

export const NewLifeHelpStyled = styled.div`
    margin-bottom: 24px;

    .accordion {
        border: none;
    }

    .accordion-button {
        text-align: center;
        display: block;
        border: none;
        background-color: transparent;
        transition: color .15s ease-in-out,
        background-color .15s ease-in-out,
        border-color .15s ease-in-out,
        box-shadow .15s ease-in-out,
        border-radius .15s ease;

        &:not(.collapsed) {
            background-color: #000000;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        span {
            border-bottom: 1px dashed #FFFFFF;
        }
    }

    .accordion-collapse {
        background-color: transparent;
        transition: height .35s ease,
        background-color .15s ease-in-out 20s;

        &.collapsing,
        &.show {
            background-color: #000000;
        }

    }
`;

export const NewLifeHeadStyled = styled.div`
    background: var(--app-bg-modal-color);
`;

export const NewLifeHeadContentStyled = styled.div`
    text-align: center;

    margin: 0 auto;
    padding: 32px 40px;
    max-width: 1024px;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        padding: 16px;
    }

    .carousel.carousel-slider .slider-wrapper {
        padding: 0 24px;
        margin: 0;
        margin-bottom: 16px;
    }

    .carousel.carousel-slider .control-dots {
        .dot {
            box-shadow: none;
            opacity: 1;
            background: var(--color-purple-highlight);
            margin: 0 4px;
            width: 4px;
            height: 4px;
            border-radius: 4px;
            transition: all .15s ease-in-out;

            &.selected {
                width: 14px;
            }

            &:hover:not(.selected) {
                background: var(--color-white);
            }
        }
    }
`;

export const NewLifeAccountCarouselStyled = styled.div`
    margin: 0 -16px;
`;

export const NewLifeContentStyled = styled.div`
    text-align: center;

    margin: 0 auto;
    padding: 32px 40px;
    max-width: 1024px;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        padding: 16px 0 48px;
    }
`;
